module.exports = __webpack_public_path__ + "img/okr.85c7dfb5.svg";